import ActionsRegistry from "./ActionsRegistry";

export const Request = async <TIn, TOut>(
  actionName: string,
  params: TIn,
  headers?: { [key: string]: string }
): Promise<TOut> => {
  const action = ActionsRegistry[`${actionName}`];
  if (!action) {
    return null as TOut;
  }

  return await action(params);
};
